export default __webpack_public_path__ + "static/1-9a124dd6b3e233b2aaa62f9ccce090f4.jpeg";